/* src/app/core/toggle-icon/toggle-icon.component.scss */
:host {
  width: inherit;
  height: inherit;
  display: inline-block;
}
.toggle-icon {
  width: inherit;
  margin: 0px !important;
  padding: 0px !important;
}
label {
  min-width: inherit;
  min-height: inherit;
  list-style: none;
  display: inline-flex;
  cursor: pointer;
}
.toggle-icon > label:nth-child(2) {
  display: none;
}
.toggle-icon.is-active > label:nth-child(1) {
  display: none;
}
.toggle-icon.is-active > label:nth-child(2) {
  display: block;
}
/*# sourceMappingURL=toggle-icon.component.css.map */
